import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireSmokerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.smokers <= 0) return false;
    if (!unassignJob(settlement, 'smokers')) return false;
    settlement.production.smokehouse.progress.pop();
    return true;
};
